import {Form, Formik} from 'formik';
import {useTranslation} from 'next-i18next';
import * as Yup from 'yup';

import {PLACE_SELECTS_WIDTH} from '@/src/signUp/emailStep/constants/selectsWidthConstants';
import CitiesSelect from '@/src/signUp/emailStep/containers/CitiesSelect';
import CountriesSelect from '@/src/signUp/emailStep/containers/CountriesSelect';
import StatesSelect from '@/src/signUp/emailStep/containers/StatesSelect';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import {Button, PageTitle, Separator, Text} from '@/src/ui';

import css from '../styles/ChangeAddressPopupLayout.module.css';

interface ChangeAddressPopupLayoutProps {
  onSubmitClick: (...args: any[]) => any;
  onCancelClick: (...args: any[]) => any;
  cityId: number;
  stateId: number;
  countryId: number;
  isLoading: boolean;
  countriesDictionary: Array<any>;
}

const getValidationSchema = (t) => {
  return Yup.object().shape({
    country_id: Yup.string().nullable().required(t('validation.field-req')),
    state_id: Yup.string().nullable().required(t('validation.field-req')),
    city_id: Yup.string().nullable().required(t('validation.field-req')),
  });
};

const ChangeAddressPopupLayout = ({
  onCancelClick,
  onSubmitClick,
  cityId,
  stateId,
  countryId,
  isLoading,
  countriesDictionary,
}: ChangeAddressPopupLayoutProps) => {
  const {t} = useTranslation(TextLocal.LOCALE_SOURCE.COMMON);

  return (
    <div className={css.popup}>
      <div className={css.heading}>
        <PageTitle
          title={t('profile.address')}
          offset={PageTitle.BOTTOM_OFFSET.OFFSET_30}
        />
      </div>
      <Separator borderWeight={Separator.BORDER_WEIGHT.THIN} />
      <Formik
        initialValues={{
          city_id: null,
          state_id: null,
          country_id: null,
        }}
        onSubmit={onSubmitClick}
        validationSchema={getValidationSchema(t)}
      >
        <Form>
          <div className={css.formContent}>
            <div className={css.input}>
              {/*@ts-ignore*/}
              <CountriesSelect
                isRequired={true}
                countriesDictionary={countriesDictionary}
                defaultCountryId={countryId}
                name={'country_id'}
                width={PLACE_SELECTS_WIDTH.WIDTH_100PR}
              />
            </div>
            <div className={css.input}>
              {/*@ts-ignore*/}
              <StatesSelect
                countryFieldName={'country_id'}
                isRequired={true}
                defaultStateId={stateId}
                name={'state_id'}
                width={PLACE_SELECTS_WIDTH.WIDTH_100PR}
              />
            </div>
            <div className={css.input}>
              {/*@ts-ignore*/}
              <CitiesSelect
                stateFieldName={'state_id'}
                isRequired={true}
                defaultCityId={cityId}
                name={'city_id'}
                width={PLACE_SELECTS_WIDTH.WIDTH_100PR}
              />
            </div>
          </div>
          <Separator borderWeight={Separator.BORDER_WEIGHT.THIN} />
          <div className={css.buttonsBlock}>
            <div className={css.cancelPseudoButton} onClick={onCancelClick}>
              <Text
                color={Text.COLOR.GREY}
                fontWeight={Text.FONT_WEIGHT.MEDIUM}
                fontSize={Text.FONT_SIZE.SIZE_16}
              >
                <TextLocal id={'create-course.cancel'} />
              </Text>
            </div>
            <Button
              color={Button.COLOR.PRIMARY}
              height={Button.HEIGHT.REGULAR}
              type={Button.TYPES.SUBMIT}
              isLoading={isLoading}
            >
              <TextLocal id={'profile.update'} />
            </Button>
          </div>
        </Form>
      </Formik>
    </div>
  );
};

export default ChangeAddressPopupLayout;
